import { render } from "./UsersComponent.vue?vue&type=template&id=83a803aa"
import script from "./UsersComponent.vue?vue&type=script&lang=js"
export * from "./UsersComponent.vue?vue&type=script&lang=js"

import "./UsersComponent.vue?vue&type=style&index=0&id=83a803aa&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__